// import axios from 'axios'
// // import { BASE_URL } from './config'


// export default axios.create({
//  baseURL: 'https://www.app-dev.api.myeasytransfer.com/v1',
// //  baseURL: ' https://www.api.myeasytransfer.com/v1',
//   timeout: 20000,
// })


import axios from 'axios'

// export const baseURL = 'https://www.app-dev.api.myeasytransfer.com/v1'
// export const baseURLSocket = 'https://www.app-dev.api.myeasytransfer.com'

export const baseURL = 'https://www.api.myeasytransfer.com/v1'
export const baseURLSocket = 'https://www.api.myeasytransfer.com'

const axiosInstance = axios.create({
  baseURL,
  timeout: 20000,
})

export default axiosInstance
